import styled from 'styled-components'

export const CustomRow = styled.div`
	display: flex;
	flex-wrap: wrap;
`

export const CustomCol = styled.div`
	margin-right: ${({ theme }) => theme.formColGap};
`

export const Label = styled.p`
	font-size: 16px;
`